import { useUser } from '@cobliteam/hooks';
import useFeatureFlags from '@cobliteam/hooks/src/useFeatureFlags';
import { Environment } from '@cobliteam/react-environments';
import { useCallback, useState } from 'react';

const env = Environment.getInstance().getEnvironment();

export default function useBlipChat({ onClose }: { onClose: () => void }) {
  const [, setBlipClient] = useState<typeof BlipChat | null>(null);
  const { getSession } = useUser();
  const session = getSession();
  const blipChatAppKey = env.blipChatAppKey;
  const featureFlags = useFeatureFlags();

  const initBlipChat = useCallback(() => {
    if (!(featureFlags.blipChat && session)) return;

    if (blipChatAppKey) {
      const blipClient = new window.BlipChat()
        .withAppKey(blipChatAppKey)
        .withCustomCommonUrl('https://cobli.chat.blip.ai/')
        .withButton({ color: '#092bfe', icon: '', right: '0', top: '0' })
        .withEventHandler(window.BlipChat.LEAVE_EVENT, () => {
          onClose();
        })
        .withAccount({
          fullName: session.user.name,
          email: session.user.email,
          extras: {
            fleetId: session.fleet.id,
            origem: 'Painel Cobli',
          },
        });

      blipClient.build();
      // blipClient.toogleChat();
      blipClient.withTarget('blip-chat');
      setBlipClient(blipClient);
      window.blipChatInstance = blipClient;
      // ⚠️ the toogleChat name is wrong, it should be toggleChat but works
      // blipClient.toogleChat();
      // blipClient.destroy();
      // blipClient.build();
    }
  }, [blipChatAppKey, featureFlags, session]);

  return {
    build: initBlipChat,
  };
}
